import React from "react";
import { MdEmail } from "react-icons/md";
import { AiFillGithub, AiFillLinkedin } from "react-icons/ai";
function Footer() {
  return (
    <div style={{ borderTop: "10px solid #e8491d" }}>
      <footer className=" my_footer text-white text-center m-0 pt-4 pb-3">
        <p className="m-0">Designed By || Shubham Chauhan || &copy; 2021</p>
        <p className="m-0">
          <AiFillGithub style={{ color: "#e8491d", fontSize: "20px" }} /> ||{" "}
          <span className="text-decoration-underline">
            <a
              href="https://github.com/chauhanshubham592"
              className="text-white"
            >
              https://github.com/chauhanshubham592
            </a>
          </span>
        </p>
        <p className="m-0">
          <AiFillLinkedin style={{ color: "#e8491d", fontSize: "20px" }} /> ||{" "}
          <span className="text-decoration-underline">
            <a
              href="https://www.linkedin.com/in/shubham-chauhan-817289215/"
              className="text-white"
            >
              https://www.linkedin.com/in/shubham-chauhan-817289215/
            </a>
          </span>
        </p>
        <p>
          <MdEmail style={{ color: "#e8491d", fontSize: "20px" }} /> ||{" "}
          <span className="text-decoration-underline">
            <a href="mailto:chauhanshubham592@gmail.com" className="text-white">
              chauhanshubham592@gmail.com
            </a>
          </span>
        </p>
      </footer>
    </div>
  );
}

export default Footer;
